export default __webpack_public_path__ + "static/media/845.fccfb83f.png";